
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import logo from '../../libs/images/logo.png'
const Header = (props) => {
    const user_id = useSelector(state => state.global.user_id)
    return (
    <div>
        {/* <div className="preloader" id="preloader">
            <div className="loader">
                <svg className="spinner" viewBox="0 0 50 50">
                    <circle className="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                </svg>
            </div>
        </div> */}

        <header className="header-area">
            <div className="header-top-bar padding-right-100px padding-left-100px">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="header-top-content">
                                <div className="header-left">
                                    <ul className="list-items">
                                        <li><a href={"tel:9899099525"}><i className="la la-phone mr-1"></i>+91 9871552247</a></li>
                                        <li><a href={"mailto:support@onstrips.com"}><i className="la la-envelope mr-1"></i>support@onstrips.com</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                       
                                <div className="col-lg-6">
                                    <div className="header-top-content">
                                        <div className="header-right d-flex align-items-center justify-content-end">
                                            <div className="header-right-action">
                                                <a href="https://apnaatravel.com/OnstripIAMadmin/vendor" target="_blank" class="theme-btn theme-btn-small theme-btn-transparent mr-1">Agent Login</a>
                                                <a href="https://apnaatravel.com/Signup" className="theme-btn theme-btn-small theme-btn-transparent mr-1">Sign Up</a>
                                                <a href="https://apnaatravel.com/Signin" className="theme-btn theme-btn-small">Login</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                        
                    </div>
                </div>
            </div>
            <div className="header-menu-wrapper padding-right-100px padding-left-100px">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="menu-wrapper">
                                <a href="#" className="down-button"><i className="la la-angle-down"></i></a>
                                <div className="logo">
                                    <a href="https://apnaatravel.com/"><img src={logo} alt="logo" width="200" /> </a>
                                    <div className="menu-toggler">
                                        <i className="la la-bars"></i>
                                        <i className="la la-times"></i>
                                    </div>
                                </div>
                                <div className="main-menu-content" >
                                    <nav>
                                        <ul>
                                        <li>
                                            <a href="https://apnaatravel.com/">Home</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/about-us">About Us</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/flight/">Flights</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/web/package">Tours Packages</a>
                                        </li>

                                        <li>
                                            <a href="https://apnaatravel.com/web/hotel?yY=1">Hotels</a>
                                        </li>

                                        <li>
                                            <a href="https://apnaatravel.com/web/outstation?yY=1">Book My Cab</a>
                                        </li>
                                        
                                        <li>
                                            <a href="https://apnaatravel.com/web/airportcab?yY=1">Air Port Taxi</a>
                                        </li>

                                        <li>
                                            <a href="https://apnaatravel.com/bus">Bus</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/M.I.C.E">M.I.C.E</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/Forex">Forex</a>
                                        </li>
                                        <li>
                                            <a href="https://apnaatravel.com/Visa">Visa</a>
                                        </li>

                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    </div>
    )
}

export default Header